import { z } from 'zod';
export const TYPES_SOURCE_SIGNATURE = [
    'contrat_artiste',
    'bon_depot',
    'bon_pret',
    'contrat_modele',
];
export const ETATS_SIGNATURE = [
    'brouillon',
    'envoyee',
    'signee',
    'refusee',
    'expiree',
    'annulee',
];
export const sourceSignatureSchema = z.strictObject({
    type: z.enum(TYPES_SOURCE_SIGNATURE),
    id: z.string().regex(/^[a-f\d]{24}$/i),
});
export const signataireSchema = z.strictObject({
    nom: z.string().trim().min(1).max(150),
    email: z.email().toLowerCase().max(200),
    telephone: z
        .string()
        .regex(/^\+[1-9]\d{7,14}$/)
        .optional(),
    role: z.enum(['galerie', 'tiers']),
    ordre: z.int().min(1).max(10),
});
export const envoiSignatureSchema = z
    .strictObject({
    source: sourceSignatureSchema,
    cleIdempotence: z.uuid(),
    signataires: z.array(signataireSchema).min(2).max(10),
    niveau: z.enum(['simple', 'avancee']).default('simple'),
    expireLe: z.iso.datetime(),
    relancePourcentage: z.int().min(1).max(99).nullable().default(50),
})
    .superRefine((v, ctx) => {
    if (!v.signataires.some((s) => s.role === 'galerie') ||
        !v.signataires.some((s) => s.role === 'tiers') ||
        new Set(v.signataires.map((s) => s.ordre)).size !== v.signataires.length ||
        new Set(v.signataires.map((s) => s.email)).size !== v.signataires.length ||
        (v.niveau === 'avancee' && v.signataires.some((s) => !s.telephone)))
        ctx.addIssue({ code: 'custom', message: 'Signataires, ordre ou téléphones invalides.' });
});
//# sourceMappingURL=signatures.js.map